import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import {
  HeaderSection as StyledHeaderSection,
  HeaderInfoContainer,
  HeaderTextContainer,
  BackButton,
} from '../../../styles/UnitsMappingStyles';

interface HeaderSectionProps {
  onBackClick: () => void;
}

const HeaderSection: React.FC<HeaderSectionProps> = memo(({ onBackClick }) => {
  const { t } = useTranslation();

  return (
    <StyledHeaderSection>
      <HeaderInfoContainer>
        <HeaderTextContainer>
          <Typography
            variant="h3"
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#262626',
              fontFamily: '"IBM Plex Sans Arabic", sans-serif',
              lineHeight: '28px',
            }}
          >
            {t('CHANNELS.UNITS_MAPPING.TITLE', 'دمج الوحدات')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              color: '#666',
              fontFamily: '"IBM Plex Sans Arabic", sans-serif',
              lineHeight: '24px',
            }}
          >
            {t('CHANNELS.UNITS_MAPPING.DESCRIPTION', 'قم بمطابقة الوحدات المستوردة من القنوات المختلفة لضمان توحيد بيانات العقار.')}
          </Typography>
        </HeaderTextContainer>
      </HeaderInfoContainer>

      <BackButton onClick={onBackClick}>
        {t('CHANNELS.UNITS_MAPPING.BACK_TO_CHANNELS', 'العودة إلى الصفحة الرئيسية')}
      </BackButton>
    </StyledHeaderSection>
  );
});

HeaderSection.displayName = 'HeaderSection';

export default HeaderSection;
